import { render, staticRenderFns } from "./HorsesTable.vue?vue&type=template&id=6356286a&"
import script from "./HorsesTable.vue?vue&type=script&lang=js&"
export * from "./HorsesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports